import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

export const useSearchParamsHandler = (key: string, defaultValue?: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (defaultValue) {
      set(defaultValue);
    }
  }, [defaultValue]);
  const add = (value: string) => {
    if (searchParams.has(key, value)) {
      return;
    }
    searchParams.append(key, value);
    setSearchParams(searchParams);
  };

  const set = (value: string) => {
    searchParams.set(key, value);
    setSearchParams(searchParams);
  };

  const get = (match?: string) => {
    return match
      ? searchParams.getAll(key).filter((val) => val.includes(match))
      : searchParams.getAll(key);
  };

  const isActive = (match?: string) => {
    return get(match).filter((val) => !!val).length > 0;
  };

  const clear = (match?: string) => {
    searchParams.delete(key, match);
    setSearchParams(searchParams);
  };

  const clearOther = (otherKey: string) => {
    searchParams.delete(otherKey);
    setSearchParams(searchParams);
  };

  return {
    add: add,
    get: get,
    set: set,
    isActive: isActive,
    remove: clear,
    removeOther: clearOther,
  };
};
